{
  "slug": "mensa-iq-requirements",
  "title": "মেন্সা আইকিউ শর্তাবলী ব্যাখ্যা করা হয়েছে",
  "description": "মেন্সা যোগ্যতা পরীক্ষায় কিভাবে উপরের দুই শতাংশ ব্যবহার করা হয়, পরীক্ষার ভিত্তিতে যোগ্যতা সংখ্যা কেন ভিন্ন হয় এবং অনলাইন স্কোর কেন ভর্তির প্রমাণ নয় তা জানুন।",
  "summary": "মেন্সা যোগ্যতা নির্ধারণ করে থাকে শতাংশের ভিত্তিতে: যোগ্যতা নির্ধারণের ফলাফল অবশ্যই ০ থেকে ১ এর মধ্যে হতে হবে। 98অনুমোদিত, সঠিকভাবে তদারকিকৃত বুদ্ধিমত্তা পরীক্ষার উপর 100%। অনুরূপ IQ সংখ্যা স্কেলের উপর নির্ভর করে।",
  "category": "তুলনা",
  "sections": [
    {
      "heading": "প্রয়োজনীয়তা একটি শতাংশ, একটি সার্বজনীন সংখ্যা নয়",
      "paragraphs": [
        "মেনসা ইন্টারন্যাশনাল ঘোষণা করেছে যে যারা সাধারণ জনসংখ্যার মধ্যে উচ্চতম দুই শতাংশের মধ্যে স্কোর করে এবং যারা সঠিকভাবে পরিচালিত এবং তদারকিকৃত একটি অনুমোদিত বুদ্ধিমত্তা পরীক্ষায় উত্তীর্ণ হয় তাদের জন্য সদস্যপদ উন্মুক্ত।",
        "দ্য 98th শতাংশ প্রায়ই কাছাকাছি 130 একটা...100, এসডি-15 স্কেল, কিন্তু অন্যান্য পরীক্ষা বিভিন্ন মানদণ্ড বিভ্রান্তি, স্কোর ধরন, এবং cutoffs ব্যবহার করো । স্বীকৃত threshold নির্দিষ্ট পরীক্ষার জন্য অবশ্যই চেক করা উচিত ।"
      ]
    },
    {
      "heading": "যোগ্যতাসম্পন্ন ফলাফল প্রদানের উপায়",
      "paragraphs": [
        "জাতীয় মেন্সা সংস্থার উপর নির্ভর করে, একজন প্রার্থী প্রশাসনিক ভর্তি পরীক্ষা দিতে পারেন অথবা অন্য কোন অনুমোদিত মূল্যায়নের প্রমাণ উপস্থাপন করতে পারেন।",
        "প্রাথমিক পেশাদার স্কোর রিপোর্ট রাখুন। যদি যোগ্যতা অর্জন করাই উদ্দেশ্য হয়, তাহলে বহিরাগত পরীক্ষার আয়োজনের আগে সংশ্লিষ্ট মেন্সা অফিসের সাথে যোগাযোগ করুন।"
      ]
    },
    {
      "heading": "প্র্যাকটিস এবং অনলাইন পরীক্ষা কি করতে পারে",
      "paragraphs": [
        "প্র্যাকটিস প্রশ্নগুলো কাউকে ফরম্যাট এবং সময় বুঝতে সাহায্য করতে পারে। এগুলো কোন যোগ্যতা প্রমাণ করে না, এবং পুনরাবৃত্তিমূলক পরীক্ষা সাধারণ দক্ষতার স্থিতিশীল পরিবর্তনের পরিবর্তে পরিচিতির উন্নতি ঘটাতে পারে।",
        "মেনসা ইন্টারন্যাশনাল বলছে যে অনলাইন পরীক্ষার ফলাফলকে শিক্ষামূলক বা নির্দেশক হিসেবে বিবেচনা করা যাবে না, যদি না প্রাপক সংস্থা স্পষ্টভাবে অন্য কিছু বলে।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "মেন্সার জন্য তোমার কি আইকিউ স্কোর লাগবে?",
      "answer": "যোগ্যতা নির্ভর করে : 98অনুমোদিত তত্ত্বাবধানে পরীক্ষার তৃতীয় শতাংশ। পরীক্ষার পরিমাপের উপর ভিত্তি করে সমতুল্য সংখ্যা ভিন্ন হতে পারে।"
    },
    {
      "question": "আমি কি অনলাইন আইকিউ ফলাফল নিয়ে মেন্সায় যোগ দিতে পারি?",
      "answer": "মেনসা ইন্টারন্যাশনাল জানিয়েছে যে অনলাইন পরীক্ষার মাধ্যমে ভর্তি করা যাবে না।"
    }
  ],
  "related": ["iq-test-vs-mensa-test", "what-is-considered-a-high-iq", "iq-percentiles"],
  "sources": [
    {
      "label": "মেনসা ইন্টারন্যাশনাল – আপনার আইকিউ পরীক্ষা করা হচ্ছে",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
